/**
 * @desc 审批
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: defs.wms.ChangeOrderApprovalDto, options?: any) {
  return updateResponse(
    http(URL + `/wms/changeOrder/approve`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
